export class WatchlistEnvironment {
  public static getName = () => 'benzinga-watchlist';
  public static getEnvironment = (env: Record<string, string>) => ({
    fastLinkConfigName: env.fastLinkConfigName ?? 'Aggregation',
    fastLinkUrl:
      env.fastLinkUrl ??
      'https://fl4.prod.yodlee.com/authenticate/USDevexProd3-130/fastlink?channelAppName=usdevexprod3',
    url: new URL(env.url ?? 'https://api.benzinga.com/'),
  });
}
